var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('div',{staticClass:"text-2xl"},[_vm._v("\n    Import opportunities from Mercury\n  ")]),_c('OpportunityList'),_c('div',{staticClass:"py-6 px-4"},[_c('Footer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }